import { render } from "./ConfirmBlockAccountModal.vue?vue&type=template&id=143e625e&scoped=true"
import script from "./ConfirmBlockAccountModal.vue?vue&type=script&lang=js"
export * from "./ConfirmBlockAccountModal.vue?vue&type=script&lang=js"

import "./ConfirmBlockAccountModal.vue?vue&type=style&index=0&id=143e625e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143e625e"]])

export default __exports__